module.exports = __webpack_public_path__ + "img/palette-outline.cc176f3.svg";